{"domain":"inglis-dev.au.auth0.com","clientId":"mfLcwKkrsTEWMrGWdUsaTuOXBFWHW18l","audience":"https://api.dev.vendor.inglis.com.au"}